module.exports = __webpack_public_path__ + "media/images/medupp-logo-brand-835105dea5e1732a228b111b26c61cee.png";